import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { InvoiceEntity } from './invoice.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk_invoice__id', ['fkInvoiceId'], {})
@Entity('invoice__file')
export class InvoiceFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_invoice__id', unsigned: true })
	public fkInvoiceId!: number;

	@ManyToOne(() => FileEntity, (file) => file.invoiceFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(() => InvoiceEntity, (invoice) => invoice.invoiceFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_invoice__id', referencedColumnName: 'id' }])
	public fkInvoice!: InvoiceEntity;
}
